export default "__VITE_ASSET__oD7_O$cl__"